import { Skeleton } from "antd";

/**
 * Trạng thái loading chuẩn (UIUX §1/§7): hiển thị skeleton trong khi tải,
 * KHÔNG hiển thị nội dung giả. Mặc định 3 dòng.
 */
export function LoadingSkeleton({ rows = 3 }: { readonly rows?: number }) {
  return <Skeleton active title paragraph={{ rows }} />;
}
